const preHeaderData = [
  ["Deal", "value", "multiples"],
  ["Equity", "value", "multiples"],
  ["Enterprise", "value", "multiples"],
  ["Modelled", "enterprise", "value", "multiples"],
  ["Total", "target", "value", "multiples"]
]

const futureHeaderData = [
  ["Deal", "value", "multiples", "Median"],
  ["Equity", "value", "multiples", "Median"],
  ["Enterprise", "value", "multiples", "Median"],
  ["Modelled", "enterprise", "value", "multiples", "Median"],
  ["Total", "target", "value", "multiples", "Median"]
]

const dealData = [
  [
    {
      label: "Deal headline",
      field: "deal_headline"
    },
    {
      label: "Deal type",
      field: "deal_type"
    },
    {
      label: "Deal status",
      field: "deal_status"
    },
    {
      label: "Deal value",
      field: "deal_value"
    }
  ],
  [
    {
      label: "Target name",
      field: "target_name"
    },
    {
      label: "Country/Region",
      field: "country"
    },
    {
      label: "Activity",
      field: "activity"
    }
  ],
  [
    {
      label: "Acquiror name",
      field: "acquiror_name"
    },
    {
      label: "Country/Region",
      field: "country"
    },
    {
      label: "Activity",
      field: "activity"
    }
  ],
  [
    {
      label: "Vendor name",
      field: "vendor_name"
    },
    {
      label: "Country/Region",
      field: "country"
    },
    {
      label: "Activity",
      field: "activity"
    }
  ],
  [
    {
      label: "Regulatory body name",
      field: "regulatory_body_name"
    },
    {
      label: "Regulatory body country",
      field: "regulatory_body_country"
    }
  ]
];

const dealDates = [
  {
    label: "Deal type",
    field: "deal_type"
  },
  {
    label: "Deal sub-type",
    field: "deal_sub_type"
  },
  {
    label: "Deal financing",
    field: "deal_financing"
  },
  {
    label: "Deal method of payment",
    field: "deal_method_of_payment"
  },
  {
    label: "Deal method of payment value",
    field: "deal_method_of_payment_value"
  },
  {
    label: "Deal status",
    field: "deal_status"
  },
  {
    label: "Rumour date",
    field: "rumour_date"
  },
  {
    label: "Announced date",
    field: "announced_date"
  },
  {
    label: "Expected completion date",
    field: "expected_completion_date"
  },
  {
    label: "Completed date",
    field: "completed_date"
  },
  {
    label: "Postponed date",
    field: "postponed_date"
  },
  {
    label: "Withdrawn  date",
    field: "withdrawn_date"
  },
  // 
  {
    label: "Last deal status date",
    field: "last_deal_status_date"
  },
  {
    label: "Last deal value, offer price, bid premium update date",
    field: "last_deal_value_offer_price_bid_premium_update_date"
  },
  {
    label: "Last deal status update date",
    field: "last_deal_status_update_date"
  },
  {
    label: "Last % of stake update date",
    field: "last_of_stake_update_date"
  },
  {
    label: "Last acquiror, target, vendor update date",
    field: "last_acquiror_target_vendor_update_date"
  },
  {
    label: "Last advisor update date",
    field: "last_advisor_update_date"
  },
  {
    label: "Last deal comment, rationale update date",
    field: "last_deal_comment_rationale_update_date"
  },
  {
    label: "Last update",
    field: "last_update"
  },
]

const dealValues = [
  {
    label: "Deal value",
    field: "deal_value"
  },
  {
    label: "Deal equity value",
    field: "deal_equity_value"
  },
  {
    label: "Deal enterprise value",
    field: "deal_enterprise_value"
  },
  {
    label: "Deal modelled enterprise value",
    field: "deal_modelled_enterprise_value"
  },
  {
    label: "Deal total target value",
    field: "deal_total_target_value"
  },
  // {
  //   label: "Initial stake (%)",
  //   field: "f"
  // },
  // {
  //   label: "Acquired stake (%)",
  //   field: "g"
  // },
  // {
  //   label: "Final stake (%)",
  //   field: "h"
  // },
  // {
  //   label: "IRR (%)",
  //   field: "i"
  // },
  {
    label: "Native currency",
    field: "native_currency"
  }
]

const preDealData = [
  {
    label: "Pre-deal target operating revenue/turnover",
    field: "revenueTurnover"  //对应下文 自定义行字段
  },
  {
    label: "Pre-deal target EBITDA",
    field: "EBITDA"
  },
  {
    label: "Pre-deal target EBIT",
    field: "EBIT"
  },
  {
    label: "Pre-deal target profit before tax",
    field: "beforeTax"
  },
  {
    label: "Pre-deal target profit after tax",
    field: "afterTax"
  },
  {
    label: "Pre-deal target total assets",
    field: "totalAssets"
  },
  {
    label: "Pre-deal target net assets",
    field: "netAssets"
  },
  {
    label: "Pre-deal target shareholders funds",
    field: "shareholdersFunds"
  },
  {
    label: "Pre-deal target market capitalisation",
    field: "capitalisation"
  }
]

const postDealData = [
  {
    label: "Post-deal target operating revenue/turnover",
    field: "revenueTurnover"
  },
  {
    label: "Post-deal target EBITDA",
    field: "EBITDA"
  },
  {
    label: "Post-deal target EBIT",
    field: "EBIT"
  },
  {
    label: "Post-deal target profit before tax",
    field: "beforeTax"
  },
  {
    label: "Post-deal target profit after tax",
    field: "afterTax"
  },
  {
    label: "Post-deal target total assets",
    field: "totalAssets"
  },
  {
    label: "Post-deal target net assets",
    field: "netAssets"
  },
  {
    label: "Post-deal target shareholders funds",
    field: "shareholdersFunds"
  },
  {
    label: "Post-deal target market capitalisation",
    field: "capitalisation"
  }
]

const futureDealData = [
  {
    label: "Future deal target sales estimate",
    field: "salesEstimate"
  },
  {
    label: "Future deal target EBITDA estimate",
    field: "EBITDA"
  },
  {
    label: "Future deal target EBIT estimate",
    field: "EBIT"
  },
  {
    label: "Future deal target net profit estimate",
    field: "profitEstimate"
  },
  {
    label: "Future deal target  net assets estimate",
    field: "assetsEstimate"
  },
  // {
  //   label: "Future deal target EPS estimate",
  //   field: "f"
  // }
];

const stockPrices = [
  {
    label: "Offer price",
    field: "offer_price"
  },
  {
    label: "Offer price Native currency",
    field: "offer_price_native_currency"
  },
  {
    label: "Bid premium - Rumour date",
    field: "bid_premium_announced_date"
  },
  {
    label: "Rumour date premium",
    field: "rumour_date_premium"
  },
  {
    label: "Bid premium - Announced date",
    field: "bid_premium_announced_date"
  },
  {
    label: "Announced date premium",
    field: "announced_date_premium"
  }
]

const stockTarget = [
  {
    label: "Target stock price 3 months prior to rumour",
    field: "target_stock_price_3_months_prior_to_rumour"
  },
  {
    label: "Target stock price 3 months prior to announcement",
    field: "target_stock_price_3_months_prior_to_announcement"
  },
  {
    label: "Target stock price prior to rumour",
    field: "target_stock_price_prior_to_rumour"
  },
  {
    label: "Target stock price prior to announcement",
    field: "target_stock_price_prior_to_announcement"
  },
  {
    label: "Target stock price at completion date",
    field: "target_stock_price_at_completion_date"
  },
  {
    label: "Target stock price after completion",
    field: "target_stock_price_after_completion"
  },
  {
    label: "Target stock price 1 week after completion",
    field: "target_stock_price_1_week_after_completion"
  },
  {
    label: "Target stock price 1 month after completion",
    field: "target_stock_price_1_month_after_completion"
  }
]

const stockAcquiror = [
  {
    label: "Acquiror stock price 3 months prior to rumour",
    field: "acquiror_stock_price_3_months_prior_to_rumour"
  },
  {
    label: "Acquiror stock price 3 months prior to announcement",
    field: "acquiror_stock_price_3_months_prior_to_announcement"
  },
  {
    label: "Acquiror stock price prior to rumour",
    field: "acquiror_stock_price_prior_to_rumour"
  },
  {
    label: "Acquiror stock price prior to announcement",
    field: "acquiror_stock_price_prior_to_announcement"
  },
  {
    label: "Acquiror stock price at completion date",
    field: "acquiror_stock_price_at_completion_date"
  },
  {
    label: "Acquiror stock price after completion",
    field: "acquiror_stock_price_after_completion"
  },
  {
    label: "Acquiror stock price 1 week after completion",
    field: "acquiror_stock_price_1_week_after_completion"
  },
  {
    label: "Acquiror stock price 1 month after completion",
    field: "acquiror_stock_price_1_month_after_completion"
  }
]

const stockVendor = [
  {
    label: "Vendor stock price 3 months prior to rumour",
    field: "vendor_stock_price_3_months_prior_to_rumour"
  },
  {
    label: "Vendor stock price 3 months prior to announcement",
    field: "vendor_stock_price_3_months_prior_to_announcement"
  },
  {
    label: "Vendor stock price prior to rumour",
    field: "vendor_stock_price_prior_to_rumour"
  },
  {
    label: "Vendor stock price prior to announcement",
    field: "vendor_stock_price_prior_to_announcement"
  },
  {
    label: "Vendor stock price at completion date",
    field: "vendor_stock_price_at_completion_date"
  },
  {
    label: "Vendor stock price after completion",
    field: "vendor_stock_price_after_completion"
  },
  {
    label: "Vendor stock price 1 week after completion",
    field: "vendor_stock_price_1_week_after_completion"
  },
  {
    label: "Vendor stock price 1 month after completion",
    field: "vendor_stock_price_1_month_after_completion"
  }
];

const dealComments = [
  {
    label: "Deal editorial",
    field: "a"
  },
  {
    label: "Date of editorial",
    field: "a"
  },
  {
    label: "Deal comments",
    field: "a"
  },
  {
    label: "Deal rationale",
    field: "a"
  },
  {
    label: "Deal editorial headline",
    field: "a"
  }
]

// 每一行 对应 preHeaderData的每一列,避免重复书写 ,对数据抽象,每一个key对应 列配置的field

//                           head1           head2            head3.. 
// revenueTurnover         revenue-head1   revenue-head2     ...

// 每一列 对应一行 ( revenueTurnover:[revenue-head1   revenue-head2]  )
const Data_PreDeal = {
  revenueTurnover: [
    // "pre_deal_target_operating_revenue_turnover",   //对应后台真实字段
    // "pre_deal_value_multiple_on_operating_revenue_turnover",
    // "pre_deal_equity_value_multiple_on_operating_revenue_turnover",
    // "pre_deal_enterprise_value_multiple_on_operating_revenue_turnover",
    // "pre_deal_modelled_enterprise_value_multiple_on_operating_revenue_turnover",
    // "pre_deal_total_target_value_multiple_on_operating_revenue_turnover"
    "pre_deal_target_operating_revenue_turnover",   //对应后台真实字段
    "pre_deal_value_multiple_on_turnover",
    "pre_deal_equity_value_multiple_on_turnover",
    "pre_deal_enterprise_value_multiple_on_turnover",
    "pre_deal_modelled_enterprise_value_multiple_on_turnover",
    "pre_deal_total_target_value_multiple_on_turnover"
  ],
  EBITDA: [
    "pre_deal_target_ebitda",
    "pre_deal_value_multiple_on_ebitda",
    "pre_deal_equity_value_multiple_on_ebitda",
    "pre_deal_enterprise_value_multiple_on_ebitda",
    "pre_deal_modelled_enterprise_value_multiple_on_ebitda",
    "pre_deal_total_target_value_multiple_on_ebitda"
  ],
  EBIT: [
    "pre_deal_target_ebit",
    "pre_deal_value_multiple_on_ebit",
    "pre_deal_equity_value_multiple_on_ebit",
    "pre_deal_enterprise_value_multiple_on_ebit",
    "pre_deal_modelled_enterprise_value_multiple_on_ebit",
    "pre_deal_total_target_value_multiple_on_ebit"
  ],
  beforeTax:[
    "pre_deal_target_profit_before_tax",
    "pre_deal_value_multiple_on_profit_after_tax",
    "pre_deal_equity_value_multiple_on_profit_before_tax",
    "pre_deal_enterprise_value_multiple_on_profit_before_tax",
    "pre_deal_modelled_enterprise_value_multiple_on_profit_before_tax",
    "pre_deal_total_target_value_multiple_on_profit_before_tax"
  ],
  afterTax:[
    "pre_deal_target_profit_after_tax",
    "pre_deal_value_multiple_on_profit_after_tax",
    "pre_deal_equity_value_multiple_on_profit_after_tax",
    "pre_deal_enterprise_value_multiple_on_profit_after_tax",
    "pre_deal_modelled_enterprise_value_multiple_on_profit_after_tax",
    "pre_deal_total_target_value_multiple_on_profit_after_tax"
  ],
  totalAssets:[
    "pre_deal_target_total_assets",
    "pre_deal_value_multiple_on_total_assets",
    "pre_deal_equity_value_multiple_on_total_assets",
    "pre_deal_enterprise_value_multiple_on_total_assets",
    "pre_deal_modelled_enterprise_value_multiple_on_total_assets",
    "pre_deal_total_target_value_multiple_on_total_assets"
  ],
  netAssets:[
    "pre_deal_target_net_assets",
    "pre_deal_value_multiple_on_net_assets",
    "pre_deal_equity_value_multiple_on_net_assets",
    "pre_deal_enterprise_value_multiple_on_net_assets",
    "pre_deal_modelled_enterprise_value_multiple_on_net_assets",
    "pre_deal_total_target_value_multiple_on_net_assets"
  ],
  shareholdersFunds:[
    "pre_deal_target_shareholders_funds",
    "pre_deal_value_multiple_on_shareholders_funds",
    "pre_deal_equity_value_multiple_on_shareholders_funds",
    "pre_deal_enterprise_value_multiple_on_shareholders_funds",
    "pre_deal_modelled_enterprise_value_multiple_on_shareholders_funds",
    "pre_deal_total_target_value_multiple_on_shareholders_funds"
  ],
  capitalisation:[
    "pre_deal_target_market_capitalisation",
    "pre_deal_value_multiple_on_market_capitalisation",
    "pre_deal_equity_value_multiple_on_market_capitalisation",
    "pre_deal_enterprise_value_multiple_on_market_capitalisation",
    "pre_deal_modelled_enterprise_value_multiple_on_market_capitalisation",
    "pre_deal_total_target_value_multiple_on_market_capitalisation"
  ]
}

const Data_PostDeal = {
  revenueTurnover: [
    // "post_deal_target_operating_revenue_turnover",   //对应后台真实字段
    // "post_deal_value_multiple_on_operating_revenue_turnover",
    // "post_deal_equity_value_multiple_on_operating_revenue_turnover",
    // "post_deal_enterprise_value_multiple_on_operating_revenue_turnover",
    // "post_deal_modelled_enterprise_value_multiple_on_operating_revenue_turnover",
    // "post_deal_total_target_value_multiple_on_operating_revenue_turnover"
    "post_deal_target_operating_revenue_turnover",   //对应后台真实字段
    "post_deal_value_multiple_on_turnover",
    "post_deal_equity_value_multiple_on_turnover",
    "post_deal_enterprise_value_multiple_on_turnover",
    "post_deal_modelled_enterprise_value_multiple_on_turnover",
    "post_deal_total_target_value_multiple_on_turnover"
  ],
  EBITDA: [
    "post_deal_target_ebitda",
    "post_deal_value_multiple_on_ebitda",
    "post_deal_equity_value_multiple_on_ebitda",
    "post_deal_enterprise_value_multiple_on_ebitda",
    "post_deal_modelled_enterprise_value_multiple_on_ebitda",
    "post_deal_total_target_value_multiple_on_ebitda"
  ],
  EBIT: [
    "post_deal_target_ebit",
    "post_deal_value_multiple_on_ebit",
    "post_deal_equity_value_multiple_on_ebit",
    "post_deal_enterprise_value_multiple_on_ebit",
    "post_deal_modelled_enterprise_value_multiple_on_ebit",
    "post_deal_total_target_value_multiple_on_ebit"
  ],
  beforeTax:[
    "post_deal_target_profit_before_tax",
    "post_deal_value_multiple_on_profit_after_tax",
    "post_deal_equity_value_multiple_on_profit_before_tax",
    "post_deal_enterprise_value_multiple_on_profit_before_tax",
    "post_deal_modelled_enterprise_value_multiple_on_profit_before_tax",
    "post_deal_total_target_value_multiple_on_profit_before_tax"
  ],
  afterTax:[
    "post_deal_target_profit_after_tax",
    "post_deal_value_multiple_on_profit_after_tax",
    "post_deal_equity_value_multiple_on_profit_after_tax",
    "post_deal_enterprise_value_multiple_on_profit_after_tax",
    "post_deal_modelled_enterprise_value_multiple_on_profit_after_tax",
    "post_deal_total_target_value_multiple_on_profit_after_tax"
  ],
  totalAssets:[
    "post_deal_target_total_assets",
    "post_deal_value_multiple_on_total_assets",
    "post_deal_equity_value_multiple_on_total_assets",
    "post_deal_enterprise_value_multiple_on_total_assets",
    "post_deal_modelled_enterprise_value_multiple_on_total_assets",
    "post_deal_total_target_value_multiple_on_total_assets"
  ],
  netAssets:[
    "post_deal_target_net_assets",
    "post_deal_value_multiple_on_net_assets",
    "post_deal_equity_value_multiple_on_net_assets",
    "post_deal_enterprise_value_multiple_on_net_assets",
    "post_deal_modelled_enterprise_value_multiple_on_net_assets",
    "post_deal_total_target_value_multiple_on_net_assets"
  ],
  shareholdersFunds:[
    "post_deal_target_shareholders_funds",
    "post_deal_value_multiple_on_shareholders_funds",
    "post_deal_equity_value_multiple_on_shareholders_funds",
    "post_deal_enterprise_value_multiple_on_shareholders_funds",
    "post_deal_modelled_enterprise_value_multiple_on_shareholders_funds",
    "post_deal_total_target_value_multiple_on_shareholders_funds"
  ],
  capitalisation:[
    "post_deal_target_market_capitalisation",
    "post_deal_value_multiple_on_market_capitalisation",
    "post_deal_equity_value_multiple_on_market_capitalisation",
    "post_deal_enterprise_value_multiple_on_market_capitalisation",
    "post_deal_modelled_enterprise_value_multiple_on_market_capitalisation",
    "post_deal_total_target_value_multiple_on_market_capitalisation"
  ]
}

const Data_FutureDeal = {
  salesEstimate:[
    "future_deal_target_sales_estimate",
    "future_deal_value_multiple_on_sales_median_estimate",
    "future_deal_equity_value_multiple_on_sales_median_estimate",
    "future_deal_enterprise_value_multiple_on_sales_median_estimate",
    "future_deal_modelled_enterprise_value_multiple_on_sales_median_estimate",
    "future_deal_total_target_value_multiple_on_sales_median_estimate"
  ],
  EBITDA: [
    "future_deal_target_ebitda",
    "future_deal_value_multiple_on_ebitda_median_estimate",
    "future_deal_equity_value_multiple_on_ebitda_median_estimate",
    "future_deal_enterprise_value_multiple_on_ebitda_median_estimate",
    "future_deal_modelled_enterprise_value_multiple_on_ebitda_median_estimate",
    "future_deal_total_target_value_multiple_on_ebitda_median_estimate"
  ],
  EBIT: [
    "future_deal_target_ebit",
    "future_deal_value_multiple_on_ebit_median_estimate",
    "future_deal_equity_value_multiple_on_ebit_median_estimate",
    "future_deal_enterprise_value_multiple_on_ebit_median_estimate",
    "future_deal_modelled_enterprise_value_multiple_on_ebit_median_estimate",
    "future_deal_total_target_value_multiple_on_ebit_median_estimate"
  ],

  profitEstimate:[
    "future_deal_target_net_profit_estimate",
    "future_deal_value_multiple_on_net_profit_median_estimate",
    "future_deal_equity_value_multiple_on_net_profit_median_estimate",
    "future_deal_enterprise_value_multiple_on_net_profit_median_estimate",
    "future_deal_modelled_enterprise_value_multiple_on_net_profit_median_estimate",
    "future_deal_total_target_value_multiple_on_net_profit_median_estimate"
  ],

  assetsEstimate:[
    "future_deal_target_net_assets_estimate",
    "future_deal_value_multiple_on_net_assets_median_estimate",
    "future_deal_equity_value_multiple_on_net_assets_median_estimate",
    "future_deal_enterprise_value_multiple_on_net_assets_median_estimate",
    "future_deal_modelled_enterprise_value_multiple_on_net_assets_median_estimate",
    "future_deal_total_target_value_multiple_on_net_assets_median_estimate"
  ],
  // EPSEstimate:[
  //   "future_deal_target_eps_estimate",
  //   "future_deal_value_multiple_on_net_assets_median_estimate",
  //   "future_deal_equity_value_multiple_on_net_assets_median_estimate",
  //   "future_deal_enterprise_value_multiple_on_net_assets_median_estimate",
  //   "future_deal_modelled_enterprise_value_multiple_on_net_assets_median_estimate",
  //   "future_deal_total_target_value_multiple_on_net_assets_median_estimate"
  // ]
}

export default {
  preHeaderData,
  dealData,
  dealDates,
  dealValues,
  preDealData,
  postDealData,
  futureHeaderData,
  futureDealData,
  stockPrices,
  stockTarget,
  stockAcquiror,
  stockVendor,
  dealComments,
  Data_PreDeal,
  Data_PostDeal,
  Data_FutureDeal
}